import {
  useDispatch,
  useSelector,
  type TypedUseSelectorHook,
} from 'react-redux';
import type { RootState, AppDispatch } from './index';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// Enterprise Onboarding selectors for easy access
export const useOnboardingState = () =>
  useAppSelector((state) => state.onboarding);
export const useEnterpriseData = () =>
  useAppSelector((state) => state.onboarding.enterprise);
export const useAdminUserData = () =>
  useAppSelector((state) => state.onboarding.adminUser);
export const usePrimaryContact = () =>
  useAppSelector((state) => state.onboarding.enterprise.primaryContact);
export const useSecondaryContact = () =>
  useAppSelector((state) => state.onboarding.enterprise.secondaryContact);
export const useBillingContact = () =>
  useAppSelector((state) => state.onboarding.enterprise.billingContact);
